<template>
  <div class="loading">
    <img src="./../../assets/images/public/loading.gif" alt>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.loading {
  position: fixed;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 2.4rem;
    height: 2.4rem;
  }
}
</style>


